// extracted by mini-css-extract-plugin
export default {"wrapper":"full-page-wrapper_wrapper__XaiAS"};